module.exports = __webpack_public_path__ + "static/media/blocker_arch.67893633.png";